module.exports = __webpack_public_path__ + "img/bb_g3_hairs.1d846aa2.svg";